<template>
  <div class="shop-pay-success-page">
    <nav_list :index="4"></nav_list>

    <div class="success-wrap">
      <div v-if="loading" class="state-card">
        <i class="el-icon-loading"></i>
        <span>支付成功页加载中...</span>
      </div>

      <div v-else-if="error" class="state-card state-card--error">
          <div class="state-main">
            <div class="state-title">支付成功页加载失败</div>
            <div class="state-desc">{{ error }}</div>
            <div class="state-actions">
              <el-button type="primary" @click="loadPageData">重新加载</el-button>
            <el-button @click="jump('/shop')">返回购票页</el-button>
            </div>
          </div>
      </div>

      <template v-else>
        <section class="success-strip">
          <div class="strip-main">
            <div class="strip-icon">
              <i class="el-icon-check"></i>
            </div>
            <div class="strip-copy">
              <div class="success-badge">TICKET BOOKED</div>
              <h1>购票成功</h1>
              <p>{{ successDesc }}</p>
            </div>
          </div>

          <div class="strip-meta">
            <div class="meta-item">
              <span>订单号</span>
              <strong>{{ orderSn || '-' }}</strong>
            </div>
            <div class="meta-item" v-if="orderSummary.productName">
              <span>票券名称</span>
              <strong>{{ orderSummary.productName }}</strong>
            </div>
            <div class="meta-item" v-if="orderSummary.serviceDate">
              <span>服务日期</span>
              <strong>{{ orderSummary.serviceDate }}</strong>
            </div>
            <div class="meta-item">
              <span>订单金额</span>
              <strong>¥ {{ orderAmount }}</strong>
            </div>
          </div>

          <div class="strip-actions">
            <el-button type="primary" @click="jump('/bus_list', { t: 2 })">查看景点订单</el-button>
            <el-button @click="jump('/shop')">继续预订门票</el-button>
          </div>
        </section>

        <div v-if="ticketTip" class="ticket-tip">
          {{ ticketTip }}
        </div>

        <section class="recommend-hero" v-if="hasProducts(startCityGroup) || hasProducts(endCityGroup)">
          <div class="recommend-hero-copy">
            <div class="section-tag">MORE TO BOOK</div>
            <h2>顺路把这趟行程一起订完</h2>
            <p>这页最重要的是推荐票券。下面优先展示和你当前订单更相关的景点门票与体验项目。</p>
          </div>
          <div class="recommend-hero-actions">
            <el-button type="text" @click="jump('/shop')">进入全部票券</el-button>
          </div>
        </section>

        <section v-if="hasProducts(startCityGroup)" class="recommend-section">
          <div class="section-head">
            <div>
              <div class="section-tag">START CITY</div>
              <h2>{{ getGroupTitle(startCityGroup, '出发城市相关票券') }}</h2>
            </div>
            <el-button type="text" @click="jump('/shop')">查看更多票券</el-button>
          </div>

          <div class="recommend-grid">
            <article
              v-for="item in startCityGroup.products"
              :key="'start-' + item.prod_no"
              class="product-card"
              @click="goProduct(item)"
            >
              <div class="product-cover">
                <img :src="getProductImage(item)" :alt="item.prod_name || '推荐票券'">
              </div>
              <div class="product-body">
                <div class="product-name">{{ item.prod_name || '推荐票券' }}</div>
                <div class="product-meta">
                  <span v-if="item.avg_scores" class="score">★ {{ item.avg_scores }}</span>
                  <span class="price">¥ {{ formatMoney(item.b2c_min_price) }}<em>起</em></span>
                </div>
              </div>
            </article>
          </div>
        </section>

        <section v-if="hasProducts(endCityGroup)" class="recommend-section">
          <div class="section-head">
            <div>
              <div class="section-tag">DESTINATION</div>
              <h2>{{ getGroupTitle(endCityGroup, '目的地相关票券') }}</h2>
            </div>
            <el-button type="text" @click="jump('/shop')">查看更多票券</el-button>
          </div>

          <div class="recommend-grid">
            <article
              v-for="item in endCityGroup.products"
              :key="'end-' + item.prod_no"
              class="product-card"
              @click="goProduct(item)"
            >
              <div class="product-cover">
                <img :src="getProductImage(item)" :alt="item.prod_name || '推荐票券'">
              </div>
              <div class="product-body">
                <div class="product-name">{{ item.prod_name || '推荐票券' }}</div>
                <div class="product-meta">
                  <span v-if="item.avg_scores" class="score">★ {{ item.avg_scores }}</span>
                  <span class="price">¥ {{ formatMoney(item.b2c_min_price) }}<em>起</em></span>
                </div>
              </div>
            </article>
          </div>
        </section>

        <div v-if="loaded && !hasProducts(startCityGroup) && !hasProducts(endCityGroup)" class="empty-box">
          <el-empty description="暂无相关票券推荐"></el-empty>
          <el-button type="primary" @click="jump('/shop')">返回购票页</el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import nav_list from '../index/nav_list.vue';

export default {
  name: 'shop-pay-success',
  components: {
    nav_list,
  },
  data() {
    return {
      loading: false,
      loaded: false,
      error: '',
      orderSn: '',
      order: {},
      startCityGroup: {
        city: null,
        products: [],
      },
      endCityGroup: {
        city: null,
        products: [],
      },
    };
  },
  computed: {
    statusText() {
      if (this.order.status_text) return this.order.status_text;
      if (this.order.order_status === 'send') return '已出票';
      if (this.order.order_status === 'paid') return '已支付';
      return '支付成功';
    },
    orderAmount() {
      return this.formatMoney(this.order.b2c_total_price || this.order.amount || 0);
    },
    successDesc() {
      return this.order.status_text || '你的景点门票已预订成功，下面整理了一些更适合同一趟出行一起预订的票券与体验。';
    },
    ticketTip() {
      return this.order.processing_text || '';
    },
    orderSummary() {
      return {
        productName: this.order.product && this.order.product.prod_name ? this.order.product.prod_name : '',
        serviceDate: this.getServiceDate(this.order),
      };
    },
  },
  mounted() {
    this.orderSn = this.$route.query.sn || this.cache('kkday_last_order_sn') || '';
    if (!this.orderSn) {
      this.error = '缺少订单号';
      this.loaded = true;
      return;
    }
    this.loadPageData();
  },
  methods: {
    async loadPageData() {
      if (!this.orderSn) return;
      this.loading = true;
      this.error = '';
      try {
        const res = await this.get('/kkday_product/orders/' + this.orderSn + '/recommendations', {
          limit: 6,
        }, 'get', false);
        this.order = res && res.order ? res.order : {};
        this.startCityGroup = res && res.start_city_group ? res.start_city_group : { city: null, products: [] };
        this.endCityGroup = res && res.end_city_group ? res.end_city_group : { city: null, products: [] };
      } catch (error) {
        this.error = '网络错误，请稍后重试';
      } finally {
        this.loading = false;
        this.loaded = true;
      }
    },
    hasProducts(group) {
      return !!(group && group.products && group.products.length);
    },
    getGroupTitle(group, fallback) {
      if (group && group.city && group.city.title) {
        return group.city.title + '相关票券';
      }
      return fallback;
    },
    getProductImage(item) {
      if (item && item.prod_img_url && item.prod_img_url.length) return item.prod_img_url[0];
      if (item && item.banners && item.banners.length) return item.banners[0];
      return require('../../../static/image/cover1.png');
    },
    goProduct(item) {
      if (!item || !item.prod_no) return;
      this.jump('/shop/info', {
        prod_no: item.prod_no,
        id: item.prod_no,
      });
    },
    formatMoney(value) {
      const num = Number(value || 0);
      return Number.isNaN(num) ? '0.00' : num.toFixed(2);
    },
    getServiceDate(order) {
      if (!order || !order.s_date) return '';
      const start = String(order.s_date).slice(0, 10);
      if (order.e_date && order.e_date !== order.s_date) {
        return start + ' 至 ' + String(order.e_date).slice(0, 10);
      }
      return start;
    },
  },
};
</script>

<style scoped>
.shop-pay-success-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.12), transparent 28%),
    linear-gradient(180deg, #f4f7fb 0%, #edf2f7 100%);
  padding-bottom: 56px;
}

.success-wrap {
  width: 1200px;
  margin: 24px auto 0;
}

.state-card,
.success-strip,
.recommend-hero,
.recommend-section,
.empty-box {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.state-card {
  min-height: 260px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  font-size: 16px;
}

.state-main {
  text-align: center;
}

.state-title {
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
}

.state-desc {
  margin-top: 12px;
  color: #64748b;
}

.state-actions {
  margin-top: 20px;
}

.success-badge,
.section-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #e8f1ff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.success-strip {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  padding: 28px 32px;
  border-radius: 24px;
}

.strip-main {
  display: flex;
  align-items: center;
  gap: 18px;
}

.strip-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #16a34a;
  color: #fff;
  font-size: 28px;
  flex-shrink: 0;
}

.strip-copy h1 {
  margin: 10px 0 8px;
  color: #0f172a;
  font-size: 32px;
  line-height: 1.15;
}

.strip-copy p {
  max-width: 620px;
  color: #64748b;
  font-size: 15px;
  line-height: 1.8;
}

.strip-meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  grid-column: 1 / -1;
}

.meta-item {
  padding: 16px 18px;
  background: #f8fafc;
}

.meta-item span,
.aside-item span {
  display: block;
  color: #64748b;
  font-size: 12px;
}

.meta-item strong,
.aside-item strong {
  display: block;
  margin-top: 8px;
  color: #0f172a;
  font-size: 16px;
  line-height: 1.5;
}

.ticket-tip {
  margin-top: 16px;
  padding: 16px 18px;
  background: #f0f7ff;
  color: #2563eb;
  font-size: 14px;
  line-height: 1.7;
}

.strip-actions {
  display: flex;
  gap: 12px;
}

.recommend-hero {
  margin-top: 24px;
  padding: 28px 30px;
  border-radius: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  background:
    linear-gradient(135deg, rgba(239, 246, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 58%),
    radial-gradient(circle at top right, rgba(59, 130, 246, 0.14), transparent 35%);
}

.recommend-hero-copy h2 {
  margin: 10px 0 8px;
  color: #0f172a;
  font-size: 34px;
  line-height: 1.15;
}

.recommend-hero-copy p {
  color: #64748b;
  font-size: 15px;
  line-height: 1.8;
}

.recommend-section,
.empty-box {
  margin-top: 24px;
  padding: 30px;
  border-radius: 24px;
}

.section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-head h2 {
  margin: 10px 0 0;
  color: #0f172a;
  font-size: 28px;
  line-height: 1.2;
}

.recommend-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.product-card {
  cursor: pointer;
  overflow: hidden;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow:
    inset 0 0 0 1px rgba(37, 99, 235, 0.14),
    0 18px 30px rgba(15, 23, 42, 0.08);
}

.product-cover {
  height: 220px;
  overflow: hidden;
  background: #e2e8f0;
}

.product-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-body {
  padding: 18px;
}

.product-name {
  height: 50px;
  color: #0f172a;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.6;
  overflow: hidden;
}

.product-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
}

.score {
  color: #f59e0b;
  font-size: 13px;
  font-weight: 700;
}

.price {
  color: #ef4444;
  font-size: 22px;
  font-weight: 700;
}

.price em {
  margin-left: 2px;
  font-style: normal;
  font-size: 12px;
  color: #94a3b8;
}

.empty-box {
  text-align: center;
}

@media (max-width: 1280px) {
  .success-wrap {
    width: calc(100% - 48px);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shop/pay_success.vue